// ./src/contexts/TalliesContext/TalliesContext.tsx
//
// Thin context wrapper around the useTallies hook. All derived data + the
// optimistic tick machinery live in the hook itself. See NotesContext for the
// pattern.

import React, { createContext, useContext } from "react";

import { useTallies, UseTalliesOptions, UseTalliesReturn } from "@/hooks/useTallies";

const TalliesContext = createContext<UseTalliesReturn | null>(null);

export interface TalliesProviderProps extends UseTalliesOptions {
  children: React.ReactNode;
}

export const TalliesProvider: React.FC<TalliesProviderProps> = ({ children, ...options }) => {
  const value = useTallies(options);

  return <TalliesContext.Provider value={value}>{children}</TalliesContext.Provider>;
};

export const useTalliesContext = (): UseTalliesReturn => {
  const context = useContext(TalliesContext);

  if (!context) {
    throw new Error(
      "useTalliesContext must be used within a <TalliesProvider>. " +
        "Wrap your component tree with <TalliesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalTalliesContext = (): UseTalliesReturn | null => {
  return useContext(TalliesContext);
};
